import { Box, Divider, Stack, Typography } from "@carrotfertility/carotene-core"
import React from "react"
import { useIntl } from "react-intl"

export function CostShareAmountBox({
  carrotCardAmount,
  personalPaymentAmount
}: {
  carrotCardAmount: string
  personalPaymentAmount?: string
}): JSX.Element {
  const intl = useIntl()
  return (
    <Stack
      divider={<Divider />}
      sx={(theme) => ({
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: theme.tokens.borderRadius.md,
        overflow: "hidden"
      })}
    >
      <CostShareAmountBoxItem
        label={intl.formatMessage({ defaultMessage: "Use Carrot Card:" })}
        amount={carrotCardAmount}
      />
      {personalPaymentAmount ? (
        <CostShareAmountBoxItem
          label={intl.formatMessage({ defaultMessage: "Use personal payment method:" })}
          amount={personalPaymentAmount}
        />
      ) : null}
    </Stack>
  )
}

function CostShareAmountBoxItem({ label, amount }: { label: string; amount: string }): JSX.Element {
  return (
    <Box
      sx={(theme) => ({
        padding: theme.tokens.spacing.md,
        backgroundColor: theme.palette.background.default,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
      })}
    >
      <Typography fontWeight="bold">{label}</Typography>
      <Typography variant="h2">{amount}</Typography>
    </Box>
  )
}
